import { UserRole } from '@fsp/types';

export const getRoleColor = (role: UserRole) => {
  switch (role) {
    case UserRole.OWNER:
      return 'error';
    case UserRole.ADMIN:
      return 'primary';
    case UserRole.APPROVER:
      return 'success';
    case UserRole.MEMBER:
      return 'default';
    case UserRole.VIEWER:
      return 'info';
    default:
      return 'default';
  }
};

export default getRoleColor;
